function createArtifactElement(tagName, className = '', text = null) {
  const element = document.createElement(tagName);
  if (className) element.className = className;
  if (text !== null) element.textContent = text;
  return element;
}

function createAction(label, dataset, secondary = false) {
  const button = createArtifactElement('button', `aichat-artifact-action${secondary ? ' aichat-artifact-action--secondary' : ''}`, label);
  button.type = 'button';
  Object.entries(dataset).forEach(([key, value]) => { button.dataset[key] = value; });
  return button;
}

export function renderArtifactList(root, { artifacts = [], getMetrics, getTags, formatTime } = {}) {
  if (!root) return;
  root.replaceChildren(...artifacts.map((artifact) => {
    const memberIds = (artifact.memberIds || [artifact.id]).join(',');
    const reuse = artifact.assetMetadata?.reuse || {};
    const revoked = reuse.revoked === true;
    const archived = reuse.archived === true;
    const unavailable = archived || revoked || reuse.selectable === false;
    const lifecycle = revoked ? ['unrevoke', '恢复复用', '已撤销复用'] : archived ? ['restore', '恢复资产', '已归档'] : ['revoke', '撤销复用', '可复用'];
    const card = createArtifactElement('article', 'aichat-artifact-card');
    const heading = createArtifactElement('span', 'aichat-artifact-heading');
    heading.append(createArtifactElement('strong', 'aichat-artifact-title', artifact.title || '素材'), createArtifactElement('span', 'aichat-artifact-time', formatTime(artifact.createdAt)));
    const header = createArtifactElement('header', 'aichat-artifact-card__head');
    header.append(createArtifactElement('span', 'aichat-artifact-icon', artifact.source?.icon || '📄'), heading);
    if (artifact.preview?.totalScore != null) {
      const score = createArtifactElement('span', 'aichat-artifact-score-wrap');
      score.append(createArtifactElement('span', 'aichat-artifact-score-label', '质量评分'), createArtifactElement('strong', 'aichat-artifact-score', String(artifact.preview.totalScore)));
      header.append(score);
    }
    card.append(header);
    const tags = getTags(artifact);
    if (tags.length) {
      const tagRoot = createArtifactElement('div', 'aichat-artifact-tags');
      tagRoot.append(...tags.map((tag) => createArtifactElement('span', 'aichat-artifact-tag', tag)));
      card.append(tagRoot);
    }
    if (artifact.preview?.title) card.append(createArtifactElement('p', 'aichat-artifact-product', artifact.preview.title));
    const metrics = getMetrics(artifact);
    if (metrics.length) {
      const metricRoot = createArtifactElement('div', 'aichat-artifact-metrics');
      metrics.forEach(([label, value]) => {
        const metric = createArtifactElement('div', 'aichat-artifact-metric');
        metric.append(createArtifactElement('span', '', label), createArtifactElement('strong', '', value));
        metricRoot.append(metric);
      });
      card.append(metricRoot);
    }
    card.append(createArtifactElement('p', 'aichat-artifact-summary', artifact.summary || '已完成资料整理。'));
    const footer = createArtifactElement('footer', 'aichat-artifact-card__foot');
    footer.append(createArtifactElement('span', `aichat-artifact-status${unavailable ? ' aichat-artifact-status--muted' : ''}`, lifecycle[2]));
    const actions = createArtifactElement('span', 'aichat-artifact-actions');
    if (!unavailable) {
      actions.append(createAction('加入画布', { artifactAdd: memberIds }), createAction('归档', { artifactLifecycle: 'archive', artifactId: memberIds }, true));
    }
    actions.append(createAction(lifecycle[1], { artifactLifecycle: lifecycle[0], artifactId: memberIds }, true));
    footer.append(actions);
    card.append(footer);
    return card;
  }));
}
